import AMap from "./AMapComp";

export default AMap;
